module.exports = __webpack_public_path__ + "static/img/no5.526b9e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardPH/img/no5.png
// module id = 8drw
// module chunks = 1